import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button, withStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import i18next from 'i18next';
import { faCalendarAlt, faChevronDown } from '@fortawesome/pro-light-svg-icons';

const styles = theme => ({
    drp: {
        width: 'max-content'
    },
    drpButton: {
        width: '100%',
        height: '100%',
        border: '1px solid #CCCCCC',
        padding: '10px',
        margin: '5px 5px 5px 0px'
    },
    calendarIcon: {
        marginRight: '3px',
        color: '#357ebd',
    },
    containerStylesContainer: {
        marginLeft: 'auto',

    },
    chevronIcon: {
        marginLeft: '7px',
        color: '#357ebd',
    },
    containerStyles: {
        width: '100%',
        // height: '44px',
    },
    valueContainer: {
        maxHeight: 0,
        display: 'flex',
        alignItems: 'center'
    }
});

// const containerStyles = {
//     width: '100%',
//     height: '44px'
// }

class ReactDateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ranges: this.parseRanges(this.props.ranges),
            currentLang: i18next.language,
        };
    }

    componentDidUpdate = () => {
        if (i18next.language !== this.state.currentLang) {
            this.setState({
                currentLang: i18next.language,
                ranges: this.parseRanges(this.props.ranges)
            });
        };
    };

    parseRanges = (ranges) => {
        const { disableTranslations, t } = this.props;

        if (disableTranslations) {
            return ranges;
        }

        let newRanges = {};

        for (let key in ranges) {
            newRanges[t('periods.' + key)] = ranges[key];
        }

        return newRanges;
    }

    render() {
        const { startDate, endDate, onApply = () => { }, classes, autoApply = true, periodLabel, customContainerStyle, customClass, onHide } = this.props;
        let { ranges } = this.state;

        let customClassAUX = typeof customClass !== undefined ? customClass : '';
        let containerStylesAUX = typeof customContainerStyle !== undefined ? customContainerStyle : '';

        let locale = {
            firstDay: 1
        };

        return (
            <React.Fragment>
                <DateRangePicker
                    initialSettings={{
                        startDate: startDate,
                        endDate: endDate,
                        ranges: ranges,
                        onApply: onApply,
                        className: classes.drp,
                        autoApply: autoApply,
                        locale: locale,
                        alwaysShowCalendars: false,
                        containerClass: clsx(classes.containerStyles, containerStylesAUX),
                    }}
                    key={this.state.currentLang}
                    onApply={onApply}
                    onHide={onHide}

                >
                    <Button className={clsx(classes.drpButton, customClassAUX)}>
                        <div className={classes.valueContainer}>
                            <FontAwesomeIcon className={classes.calendarIcon} icon={faCalendarAlt} />
                            {periodLabel}
                        </div>
                        <div className={clsx(classes.containerStylesContainer, "pull-right")}>
                            <FontAwesomeIcon className={classes.chevronIcon} icon={faChevronDown} />
                        </div>
                    </Button>
                </DateRangePicker>
            </React.Fragment>
        );
    }
}

export default withTranslation('common')(withStyles(styles)(ReactDateRangePicker));